import { render } from "./documentSpec.vue?vue&type=template&id=5a6f5867"
import script from "./documentSpec.vue?vue&type=script&lang=js"
export * from "./documentSpec.vue?vue&type=script&lang=js"

import "./documentSpec.vue?vue&type=style&index=0&id=5a6f5867&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__